module.exports = __webpack_public_path__ + "img/3.0ba9fae3.svg";